<template>
  <div
    class="status-container-log"
    :class="{'clickable' : hasReviewSteps}"
    @click="toggleShowTimeline"
  >
    <div class="d-flex justify-content-between align-items-center w-100">
      <div class="d-flex align-items-center position-relative">
        <div
          class="status--row-first"
          :class="firstNodeColorClass"
        ></div>
        <div
          class="status-line"
          :class="{'status-line--gradient' : !showTimeline}"
        ></div>
        <div class="status-label">
          <div
            v-if="transaction.id"
            class=""
            :class="transactionStatusLabelClass"
          >
            <img
              v-if="transactionIsLocked"
              class="transaction-status-block-icon ml-2"
              alt="transaction-locked-icon"
              :src="
                    require(`@/assets/img/icons/${transactionLockedByIcon}.svg`)
                  "
            />
            <span
              class="ml-2"
              :class="transactionStatusLabelClass"
              v-tooltip="transactionStatusTooltip"
            >{{ transactionStatusLabel }}
              <inline-svg
                :src="require('@/assets/img/icons/icon-watch.svg')"
                v-if="transactionIsProcessing"
                class="pending-icon"
              />

            </span>
            <small class="ml-3">{{currentStatus()}}</small>
          </div>
        </div>
      </div>
      <div
        class="show-history"
        v-if="hasReviewSteps && place !== 'detail'"
      >
        <span>{{$t('transactions_review_status_log_check_history')}}</span>
        <inline-svg
          class="history-arrow"
          :class="{'history-arrow-rotate' : showTimeline}"
          :src="require('@/assets/img/icons/chevron-down-blue.svg')"
          alt="arrow-down"
        />
      </div>
    </div>
  </div>

</template>

<script>
import _transactionStatusHandlerMixin from '../../../_mixins/_transactionStatusHandlerMixin'
import _transactionAndExpenseCommon from '../../../_mixins/_transactionAndExpenseCommon'

import InlineSvg from 'vue-inline-svg'
export default {
  name: 'TransactionCurrentStatus',
  mixins: [_transactionStatusHandlerMixin, _transactionAndExpenseCommon],
  props: {
    showTimeline: {
      type: Boolean,
      required: true
    },
    hasReviewSteps: {
      type: Boolean,
      required: true
    },
    place: {
      type: String,
      default: ''
    }
  },
  components: {
    InlineSvg
  },
  computed: {
    firstNodeColorClass () {
      if (this.transactionIsProcessing) {
        return 'node--pending'
      }
      if (this.transactionIsAuthorization) {
        return 'node--active'
      }
      if (this.transaction?.status?.code === 'KO') {
        return 'node--red'
      }

      if (this.transactionIsPersonalExpense) {
        return 'node--red'
      }

      if ((this.isAdmin || this.isBookKeeper) && this.transactionIsAccounted) {
        return 'node--accounted'
      }

      if (this.transactionIsApproved) {
        return 'node--approved'
      }

      if (this.transactionIsRejected) {
        return 'node--red'
      }

      if (this.transactionIsDraft) {
        return 'node--warning'
      }

      if ((this.transactionIsAwaitingReview || this.transactionInOfficeFlowRevision) && this.transactionIsCompleted) {
        if (this.userCanReviewExpense && this.isInExpensesSection) {
          return 'node--active'
        }
        if (this.userCanReviewExpense && !this.isInExpensesSection) {
          return 'node--warning'
        }
        if (!this.userCanReviewExpense) {
          return 'node--active'
        }
      }

      if (this.transactionIsAwaitingReview && this.transactionIsCompleted) {
        return this.isInExpensesSection
          ? 'node--active'
          : 'node--warning'
      }

      if (!this.transactionIsCompleted && this.transactionIsAwaitingReview) {
        if (this.$route.name.includes('my_')) return 'node--warning'
        return 'node--incompleted'
      }

      if (this.transactionIsCompleted) {
        return 'node--active'
      }
      return ''
    }
  },
  methods: {
    toggleShowTimeline () {
      if (this.hasReviewSteps) {
        this.$emit('update:showTimeline', !this.showTimeline)
        this.$emit('toggleTimeline', !this.showTimeline)
      }
    },
    currentStatus () {
      return this.transaction?.transactionReviewStatusLogs[0]?.nextReviewFlowStep?.name
    }
  }

}
</script>
<style scoped lang="scss" src="../../../_styles/transaction-review-status-log-styles.scss"></style>

<style lang="scss" scoped>
small {
  color: var(--text-heading);
}
.show-history {
  font-size: 12px;
  color: var(--text-link);
}
.history-arrow {
  width: 15px;
  height: 18px;
  stroke-width: 2;
  transition: all 0.2s ease;

  &-rotate {
    transform: rotateZ(-180deg);
  }
}
.node {
  &--pending {
    background-color: var(--gray);
    opacity: 0.72;
  }
  &--active {
    background-color: var(--semantic-brand-main);
  }
  &--red {
    background-color: var(--semantic-negative-main);
  }
  &--warning {
    background-color: var(--semantic-alert-main);
  }
  &--incompleted {
    background-color: var(--text-body);
  }
  &--approved {
    background-color: var(--semantic-positive-main);
  }
  &--accounted {
    background-color: var(--text-heading);
  }
}
.pending {
  color: var(--gray);
  opacity: 0.72;
}
.pending-icon {
  position: relative;
  right: 0px;
  top: -6px;
  width: 10px;
  height: 10px;
}
</style>
